import React from 'react'
import styled from 'styled-components'
import { ReactComponent as SadFace } from "../../Assets/iconsv2/generic/sadFace.svg";
import { useTranslate } from '@tolgee/react';
const EmptyChatList = () => {
    const { t } = useTranslate();
    return (

        <EmptyCallListWrapper>
            <SadFace />
            <p>{t('chat.chat_empty_list')}</p>
        </EmptyCallListWrapper>

    )
}

export default EmptyChatList

const EmptyCallListWrapper = styled.div`
display:flex;
flex-direction:column;
gap:8px;
align-items:center;
justify-content:center;
margin:auto;
color:${({ theme }) => theme.menu.secondaryTextColor};
`